<template>
	<div>
		<CModal title="Détails du panier" size="lg" :show.sync="showModal" :key="key">
			<template v-if="showModal">
				<GDataTableRemote
					class="mt-3"
					ref="mainTable"
					:remote-url="queryUrl"
					:fields="fields"
					:items-per-page="10"
					hover
					striped
					sorter
					columnFilter
					pagination>
					<template #shippingNumber="{ item }">
						<td>
							<template v-if="item.shippingNumber">
								<a
									target="_blank"
									:href="`https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=${item.shippingNumber}`">
									{{ item.shippingNumber }}
								</a>
							</template>
							<template v-else>
								<CIcon name="cil-ban"></CIcon>
							</template>
						</td>
					</template>
					<template #state="{ item }">
						<td>
							<CBadge :color="statusColor[item.state]">{{
								statusTranslation[item.state]
							}}</CBadge>
						</td>
					</template>
				</GDataTableRemote>
			</template>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Fermer</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import GDataTableRemote from '../ghostlexly-components/GDataTableRemote';

	export default {
		components: { GDataTableRemote },
		data() {
			return {
				key: 0,
				fields: [
					{ key: 'id', label: 'Identifiant unique' },
					{ key: 'name', label: 'Produit' },
					{ key: 'price', label: 'Prix' },
					{ key: 'state', label: 'Statut' },
					{ key: 'shippingNumber', label: 'Lien de suivi', filter: false, sorter: false },
				],
				statusTranslation: {
					'cart_product.pending': 'En attente',
					'cart_product.label_printed': 'En préparation',
					'cart_product.orphan': 'En préparation',
					'cart_product.scanned': 'Expédié',
				},
				statusColor: {
					'cart_product.pending': 'danger',
					'cart_product.label_printed': 'warning',
					'cart_product.orphan': 'warning',
					'cart_product.scanned': 'success',
				},
				showModal: false,
				queryUrl: '',
			};
		},
	};
</script>
